<template>
  <v-dialog persistent v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">DO解除確認画面</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="!Q2 || !Q3 || !cancelReason"
          @click="submit"
          class="ml-2"
          >解除申請</v-btn
        >
        <v-btn @click="show = false" class="ml-2">{{
          $t('app.buttons.back')
        }}</v-btn>
      </v-card-actions>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              label="Ｑ１解除する理由を入力："
              v-model="cancelReason"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <label>Ｑ２：旧伝票は事業本部で</label>
            <v-radio-group v-model="Q2">
              <v-radio
                :value="false"
                key="1"
                label="Ａ．検収されている"
              ></v-radio>
              <v-radio
                :value="true"
                key="2"
                label="Ｂ．検収されていない"
              ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <label
              >Ｑ３：検収されていない場合、旧伝票は廃棄するよう依頼しましたか？</label
            >
            <v-radio-group v-model="Q3">
              <v-radio :value="true" key="1" label="Ａ．はい"></v-radio>
              <v-radio :value="false" key="2" label="Ｂ．いいえ"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['deliveryOrder'],
  data: () => ({
    show: false,
    cancelReason: null,
    Q2: null,
    Q3: null,
    errors: {
      NEXT_MONTH_CAN_NOT_CANCEL: '月が変われば、DO解除作業はできなくなる',
      DATA_FROZEN: 'データは凍結済状態ですので該当操作を実施できません',
      SHIPMENT_HAS_CHANGED:
        '当該データのステータスは更新されたため、画面更新してからもう一度お試してください。',
    },
  }),
  methods: {
    submit() {
      this.$http
        .put(
          `delivery-orders/${
            this.deliveryOrder.id
          }/cancel-confirm-apply?version=${this.deliveryOrder.version}`,
          {
            cancelReason: this.cancelReason,
          }
        )
        .then(() => {
          this.$message('', 'DO解除承認待ち')
          this.$emit('refresh')
          this.show = false
        })
        .catch((res) => {
          this.$showError(res)
        })
    },
    popup() {
      this.show = true
    },
  },
}
</script>
